import { SOLUTIONS } from 'context/solutions/constants';

export const AFEX_SOLUTIONS = [
  {
    label: SOLUTIONS.ACCESS_AND_RETENTION.TITLE,
    href: SOLUTIONS.ACCESS_AND_RETENTION.LINK,
  },
  {
    label: SOLUTIONS.BIG_DATA_ANALYTICS.TITLE,
    href: SOLUTIONS.BIG_DATA_ANALYTICS.LINK,
  },
  {
    label: SOLUTIONS.EFFICIENT_MARKETS.TITLE,
    href: SOLUTIONS.EFFICIENT_MARKETS.LINK,
  },
];
